import script from "./MSM_SA_008.vue?vue&type=script&setup=true&lang=js"
export * from "./MSM_SA_008.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__